const rankingItems = [
  {
    rank: 1,
    title: '某选秀冠军签约内幕：合同暗藏天价违约金条款',
    heat: '98.6万',
    trend: 'up',
    tag: '选秀内幕',
  },
  {
    rank: 2,
    title: '电竞大赛决赛疑似假赛录音全网传播',
    heat: '87.3万',
    trend: 'up',
    tag: '电竞爆料',
  },
  {
    rank: 3,
    title: '综艺导师被指收钱保送选手引争议',
    heat: '76.1万',
    trend: 'up',
    tag: '导师争议',
  },
  {
    rank: 4,
    title: '网红主播大赛数据造假产业链曝光',
    heat: '65.8万',
    trend: 'down',
    tag: '深度调查',
  },
  {
    rank: 5,
    title: '才艺大赛评委私下聊天记录泄露',
    heat: '54.2万',
    trend: 'up',
    tag: '评委黑幕',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8 md:mb-12 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热度榜单
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              每日大赛黑料热门内容实时排行，吃瓜群众都在看
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="px-3 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">今日</span>
            <span className="px-3 py-1.5 text-foreground-500 text-xs font-medium rounded-full hover:bg-background-100 cursor-pointer whitespace-nowrap">本周</span>
            <span className="px-3 py-1.5 text-foreground-500 text-xs font-medium rounded-full hover:bg-background-100 cursor-pointer whitespace-nowrap">本月</span>
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 py-4 px-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer border-b border-background-200/60 last:border-b-0"
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="mt-1 text-sm md:text-base font-semibold text-foreground-900 leading-snug hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                <i className={`text-sm ${item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-secondary-500'}`}></i>
                <span className="text-sm font-semibold text-foreground-700 whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}